import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IUserService } from '../../../../user/user.service';
import { ListViewMode } from '../../../../user/user.store';
import { ProjectDetailsImageListControls } from '../components/ProjectDetailsImageListControls';

export const ProjectDetailsImageListControlsContainer = observer((): ReactElement => {
  const userService = useInjection(IUserService.$);

  const handleViewModeChange = async (mode: ListViewMode): Promise<void> => {
    await userService.setProjectImageListViewMode(mode);
  };

  return (
    <ProjectDetailsImageListControls
      viewMode={userService.data.projectImageListViewMode}
      onViewModeChange={handleViewModeChange}
    />
  );
});
